import React, { lazy, Suspense } from 'react';

const LazyLocationList = lazy(() => import('./LocationList'));

const LocationList = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyLocationList {...props} />
  </Suspense>
);

export default LocationList;
